import { gql } from "@apollo/client";

const USEREMAILREGISTERED = gql`
  mutation userEmailRegistered($email: String!, $agentId: ID!) {
    userEmailRegistered(email: $email, agentId: $agentId) {
      success
      result
      error
    }
  }
`;
export default USEREMAILREGISTERED;
